import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { MaterialWithTmpFile } from '@/resources/materials/types';

type Badge = {
  icon: string;
  color: string;
};

type Props = {
  material: MaterialWithTmpFile;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'FileInfoBtn',
  props: {
    material: null
  },
  setup(__props: any) {



const isValidFileObject = (file: any) => file && typeof file === "object";

const badgeType = computed(() => (material: MaterialWithTmpFile): Badge => {
  if (isValidFileObject(material?.tmpFile)) return { icon: 'mdi-information-outline', color: 'warning' };
  if (isValidFileObject(material?.file)) return { icon: 'mdi-checkbox-marked-circle-outline', color: 'success' };
  return { icon: 'mdi-close', color: 'error' };
});

const hasFile = computed(() => (value: MaterialWithTmpFile) => {
  return isValidFileObject(value?.tmpFile) || isValidFileObject(value?.file) || false;
});

return { __sfc: true,isValidFileObject, badgeType, hasFile }
}

})